<template>
  <v-row
    class="SubscriptionConsumptionEmptyStateFeatures"
    data-locator="subscription-consumption-empty-state-features"
    justify="center"
  >
    <v-col
      v-for="feature in features"
      :key="feature.key"
      cols="12"
      sm="6"
      md="4"
    >
      <AppCard
        elevation="0"
        class="h-100 text-left"
        :data-locator="`subscription-consumption-empty-state-feature-${feature.key}`"
      >
        <img
          :src="feature.visual"
          alt=""
          aria-hidden="true"
          data-locator="subscription-consumption-empty-state-feature-visual"
          class="mb-4 w-100"
        />

        <h3 class="mb-2 text-text-primary">
          {{ $t(`subscriptions.views.SubscriptionConsumption.emptyState.features.${feature.key}.title`) }}
        </h3>

        <p class="text--small text-text-secondary">
          {{ $t(`subscriptions.views.SubscriptionConsumption.emptyState.features.${feature.key}.text`) }}
        </p>
      </AppCard>
    </v-col>
  </v-row>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  import AppCard from '@/common/AppCard.vue'
  import i18n, { type AvailableLocale } from '@/plugins/i18n'

  const DEFAULT_LOCALE: AvailableLocale = 'fr'
  const FEATURE_KEYS = ['redaction', 'qa', 'logs'] as const

  export default defineComponent({
    name: 'SubscriptionConsumptionEmptyStateFeatures',
    components: { AppCard },
    computed: {
      safeLocale (): AvailableLocale {
        return (i18n.global.availableLocales as string[]).includes(this.$i18n.locale)
          ? this.$i18n.locale as AvailableLocale
          : DEFAULT_LOCALE
      },
      features (): Array<{ key: string, visual: string }> {
        return FEATURE_KEYS.map(key => ({
          key,
          visual: new URL(
            `../../assets/img/subscription/dataroom/visual-${key}-${this.safeLocale}.svg`,
            import.meta.url,
          ).href,
        }))
      },
    },
  })
</script>

<style lang="scss" scoped>
.SubscriptionConsumptionEmptyStateFeatures {
  // This is indeed a magic number,
  // but it is used to ensure that the cards are not too wide on large screens
  // Confirmed with Marine. The basic idea is to ensure that the illustrations are legible enough
  // Because of that, the 944px max from the mockup is too small in practice.
  // The reference is around 300px in width
  max-width: 1100px;
}
</style>